import axios from "axios"
export const toggleScreenActive = (content, token) => {
    return axios.post(process.env.REACT_APP_API_URL + '/toggleScreenActive', content, {
        headers: {
            'Authorization': `${token}`
        }
    });
}